import type { User } from "@lumen/shared";
import { OrganizationWorkspace } from "./OrganizationPage";

export function OrganizationEditPage({
  permissions,
  user,
}: {
  permissions: string[];
  user: User;
}) {
  return (
    <OrganizationWorkspace permissions={permissions} user={user} mode="edit" />
  );
}
